<template>
  <section
    class="coupon-card-wrapper"
    :class="displayModeClassName"
    @click="click"
  >
    <!-- 不支持叠加使用 -->
    <div v-if="isRenderOverlay" class="no-support-overlay flex-start">
      <span>{{ text.nosupport }}</span>
    </div>
    <!-- 侧边背景-半圆 -->
    <div class="circular left" :style="{ background }"></div>
    <div class="circular right" :style="{ background }"></div>

    <div :class="overlayAndMask.showMask ? 'mask' : ''">
      <!--优惠券标识符-->
      <div class="Identifier" v-if="isCoupontListIcon && subscript(data)">
        {{ subscript(data) }}
      </div>
      <!-- 在绑定手机号用 -->
      <slot></slot>
      <div class="top space-between">
        <!-- 描述信息 -->
        <div class="top-desc">
          <!-- 价格 -->
          <div class="desc price">{{ couponDiscount }}</div>
          <!-- 使用条件 -->
          <div class="desc condition">
            {{
              $t('coupon.discount_condition3', {
                currencySymbol: data.currency,
                amount: conditionPrice,
              })
            }}
          </div>
          <!-- 截止日期 -->
          <div class="deadline" v-if="isExpireInXXMinute">
            {{ validityPeriod }}
          </div>
          <!-- 失效倒计时 -->
          <div v-if="data.expireInXXMinute" class="countdown-body">
            {{ text.countdown }}
            <span class="time">
              <Countdown :userCouponExpireTime="data.userCouponExpireTime" />
            </span>
          </div>
        </div>
        <template v-if="notCheck">
          <!-- 选择样式 h5&gt-->
          <div class="checked disabled" v-if="overlayAndMask.showMask"></div>
          <MBIcon
            v-else
            defaultClass="colour"
            class="checked"
            :name="data.selected ? 'c-checked' : 'c-unchecked'"
            :size="54"
          />

          <!-- pc选中 -->
          <MBIcon
            v-if="
              !overlayAndMask.showMask &&
              data.selected &&
              displayModeClassName === 'display-desktop'
            "
            defaultClass="colour"
            name="c-selected-red"
            :size="48"
          />
        </template>
        <template>
          <slot name="custom"></slot>
        </template>
      </div>
      <!-- 分割线 -->
      <div class="dividing-line"></div>
      <div
        class="bottom"
        :class="isExpireInXXMinute ? 'deadline' : 'countdown'"
      >
        <!-- 折扣券显示最高减xxx金额 -->
        <div class="desc condition" v-if="data.couponType === 2">
          {{
            $t('coupon.discount_condition4', {
              currencySymbol: data.currency,
              amount: couponMaxDeducePrice,
            })
          }}
        </div>
        <div
          :class="['nouse', data.couponType === 2 ? 'not-first-line' : '']"
          v-if="showNotUseReason(data)"
        >
          {{ notUseReasonDesc(data) }}
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  // 优惠券卡片 - PC&H5&GT
  import MBIcon from '@/components/MBIcon'
  import Countdown from '../Countdown'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { currentLevelShort } from '@/utils/members'
  import { mapState } from 'vuex'
  import { getCouponDiscount, getBracketsData, isNewGenshin } from '../utils'

  export default {
    name: 'CouponCard',
    mixins: [styleConfiguration],
    components: {
      MBIcon,
      Countdown,
    },
    props: {
      // 优惠券列表 不显示勾选
      notCheck: {
        type: Boolean,
        default: true,
      },
      // 已经选中的优惠券列表
      selectedCoupons: {
        type: Array,
        default: () => [],
      },
      // 当前优惠券
      data: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      ...mapState(['gameName', 'selectedSkuInfo', 'isDesktop']),

      // 只有在优惠券列表展示角标
      isCoupontListIcon() {
        const routeNames = ['Coupon', 'historyCoupon']
        const rname = this.$route?.name || ''
        return routeNames.includes(rname)
      },

      displayModeClassName() {
        if (this.isDesktop) return 'display-desktop'
        if (this.isTurbo) return 'display-turbo'
        return 'display-mobile'
      },

      // 是否展示【是否叠加的tips】
      isRenderOverlay() {
        return false
        // if (this.isDesktop) return false
        // return this.overlayAndMask.showOverlay
      },
      isExpireInXXMinute() {
        return !(this.data && this.data.expireInXXMinute)
      },
      background() {
        let ncolor = ''
        if (this.isDesktop) {
          ncolor = this.moduleBackColor.backgroundColor
        } else {
          if (this.gameName === 'mobile-legends') {
            ncolor = '#273758'
          } else if (this.gameName === 'pubgm') {
            ncolor = '#303841'
          } else if (isNewGenshin(this.gameName)) {
            ncolor = '#FFFFFF'
          } else {
            ncolor = this.discountColor.backgroundColor
          }
        }
        if (this.isCoupontListIcon) {
          ncolor = '#1d1d27'
        }

        return ncolor || '#39394B'
      },
      text() {
        // 文案
        return {
          nosupport: this.$t('coupon.nosupport'),
          countdown: this.$t('coupon.countdown'),
        }
      },
      conditionPrice() {
        return this.$options.filters['formatMoney'](
          this.data?.conditionPrice || 0
        )
      },
      couponMaxDeducePrice() {
        return this.$options.filters['formatMoney'](
          this.data?.couponMaxDeducePrice || 0
        )
      },
      overlayAndMask() {
        // 不可叠加标签和蒙层
        // 注：修改时注意判断顺序
        // 本张券本套餐不可用时 有蒙层 无标签
        if (!this.data?.webEnable) {
          return { showMask: true, showOverlay: false }
        }
        // 本张优惠券是选中状态时，没有标签 不蒙层
        // 当前没有选中的优惠券时，没有标签 不蒙层
        if (this.selectedCoupons.length === 0 || this.data.selected) {
          return { showMask: false, showOverlay: false }
        }
        // 当本张优惠券与已选中的优惠券不可叠加使用时，券加蒙层，展示标签”不可叠加使用“
        // 当本张优惠券与已选中的优惠券可叠加使用时，券不加蒙层，没有标签

        // const canOverlay = this.currentIsOverlay(
        //   this.selectedCoupons,
        //   this.data
        // )
        return { showMask: false, showOverlay: false }
      },
      validityPeriod() {
        // 有效期
        // 当券失效时间大于24小时，展示”有效期至xx年xx月xx日“
        if (!this.expireInXXMinute) {
          const userCouponExpireTime =
            this.data?.userCouponExpireTime * 1000 || 0
          const text = this.$t('coupon.validity_period')
          const dateformat = getBracketsData(text)
          const dt = this.$options.filters['formatTime'](
            userCouponExpireTime,
            dateformat
          )
          return this.$t('coupon.validity_period', {
            [dateformat]: dt,
          })
        }
        return ''
      },
      couponDiscount() {
        return getCouponDiscount(this.data)
      },
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
      subscript({ birthdaySend = false, vipLevel = -1 }) {
        if (birthdaySend) return this.$t('darkColorCoupon.birthday_exclusive')
        if (vipLevel > -1) return currentLevelShort(vipLevel)
        return ''
      },
      click() {
        // 切换选中状态
        this.$emit('click', this.data)
      },
      /**
       * 本张优惠券与已选中的优惠券是否可以叠加使用
       * 返回值：true 可以叠加，false不可以叠加
       */
      currentIsOverlay(selectedCoupons, data) {
        // 所有优惠券（包括当前和选中的）的状态都是可以叠加状态时，返回true
        const noSupportConditionOverlay = selectedCoupons.filter(
          (item) => !item.conditionOverlay
        )
        // 如果查询到有不支持叠加的优惠券
        if (noSupportConditionOverlay.length > 0) return false
        // 返回当前优惠券的叠加状态
        return data.conditionOverlay
      },
      showNotUseReason(data = {}) {
        return !data.webEnable && [1, 2].includes(data.notUseReasonCode)
      },
      notUseReasonDesc(data = {}) {
        return data.notUseReasonCode === 1
          ? this.$t('coupon.nouse_reason_1')
          : data.notUseReasonCode === 2
          ? this.$t('coupon.nouse_reason_2')
          : ''
      },
    },
  }
</script>

<style lang="scss" src="./CouponCard.scss" scoped></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './CouponCard_pc.scss';
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    @import './CouponCard_pc.scss';
  }
</style>
